import { AttachmentFragment } from '@spotify/confidence-graphql';
import {
  DefaultArtifactCard,
  DefaultArtifactListItem,
} from '@spotify/plugin-confidence-projects-react';

type ResolvedNameHook = (artifact: AttachmentFragment) => string | undefined;

export interface ResolvedListItemProps {
  artifact: AttachmentFragment;
  onSelect: () => void;
  onDelete?: () => void;
}

export interface ResolvedCardProps {
  artifact: AttachmentFragment;
  onClick: () => void;
}

export const makeResolvedArtifactWrappers = (
  useResolvedName: ResolvedNameHook,
) => {
  const ListItem = ({
    artifact,
    onSelect,
    onDelete,
  }: ResolvedListItemProps) => (
    <DefaultArtifactListItem
      artifact={artifact}
      resolvedDisplayName={useResolvedName(artifact)}
      onSelect={onSelect}
      onDelete={onDelete}
    />
  );

  const Card = ({ artifact, onClick }: ResolvedCardProps) => (
    <DefaultArtifactCard
      artifact={artifact}
      resolvedDisplayName={useResolvedName(artifact)}
      onClick={onClick}
    />
  );

  return { ListItem, Card };
};
